import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { lang_confirmaEncu } from 'app/idiomas/i18n/confirmarEncu/confirmaEncu.lang';
import { EstatusService } from 'app/main/wizard-cgo/services/statusEncuesta.service';
// import { SurveyStatusService } from 'app/main/pagina/wizard-cgo/tools/survey-status/survey-status.service';
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import * as backInter from 'app/auth/auth-data.model';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import {MatSnackBar} from '@angular/material/snack-bar';
const moment = require('moment');
const momentTz = require('moment-timezone');
import { AuthService } from 'app/auth/auth.service';
import { IdiomasService } from 'app/main/wizard-cgo/services/idiomas.service';
import { Cierren35Service } from 'app/main/wizard-n35encuestador/services/cierren35.service';
import { WizardN35EncuestadorService } from 'app/main/wizard-n35encuestador/services/wizardn35encuestador.services';
import { StatusEncuestasNormV35Service } from 'app/main/wizard-n35encuestador/services/normv3/statusEncu.service';
import { zonasUTC } from 'app/main/pagina/zonasUtc';
@Component({
  selector: 'app-estatus-encuesta',
  templateUrl: './estatus-encuesta.component.html',
  styleUrls: ['./estatus-encuesta.component.scss']
})
export class EstatusEncuestaComponent implements OnInit {
statusSurvey:number;//variable que habilita btn cerrarEncuesta o abrirEncuesta;
// Datos certificar vigente
productoCertificar: backInter.prodNorma35;
tokenMas:any;
tokenMenos:any;
token:any;
instituto:any;
idSurvey:any;
cerrarEncuestaResul: number;
//zonas horarias
zonasUTC = zonasUTC;
idiomaUtc: string;
instUtc: number;
indiceZona: number;
diferenciaUtc: number;
offsetPipe: string;

historySurveyActiDesacti:any[]= [];
fechaUltimaSurveyActiDesacti:any;
surveyActiDesacti:boolean=false;
idiomaActual:string;
nameUserAdmin:any="";
userData:any;
nivelNotificacion:number;
  constructor(
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private statusEncuesta: EstatusService,
    private programacionService: ProgramacionService,
    private wizardService: WizardService,
    private _snackBar: MatSnackBar,
    public authService: AuthService,
    private idiomasService: IdiomasService,
    private statusEncuestaNorma: Cierren35Service,
    private wizardService35: WizardN35EncuestadorService,
    private statusEncuestaNormaV3: StatusEncuestasNormV35Service,
  ) {
    lang_confirmaEncu.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    if(localStorage.getItem('userBypass')){
      this.userData=JSON.parse(localStorage.getItem('userBypass'));
      // console.log(this.userData.level);
      if(this.userData.level==3 || this.userData.level==2){
        // this.validationUser=true;
        this.nameUserAdmin=this.userData.user;
      }
      else{
        // this.validationUser=false;
        this.nameUserAdmin="";
      }
    }

  }

  ngOnInit() {
    this.obtieneCertificarActual();
    this.obtieneInstituto();
    // this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == this.instUtc);
    this.calculoOffsetPipe();
    this.traduceTextosTS();
  }

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    // console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; break;
case '2': case 'CAyC': this.instituto = 'CAyC'; break;
case '3': case 'HK': this.instituto = 'HK'; break;
case '4': case 'SGP': this.instituto = 'SGP'; break;
case '5': case 'TK': this.instituto = 'TK'; break;
case '6': case 'FL': this.instituto = 'FL'; break;
case '11': case 'BR': this.instituto = 'BR'; break;
case '18': case 'AMCO': this.instituto = 'AMCO'; break;
    }
    console.log("Instituto "+this.instituto);
  }


  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.programacionService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            if(fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')){
              this.productoCertificar = producto;
              console.log("informacion:", producto);
              this.tokenMas= producto.tokenMas50;
              this.tokenMenos= producto.tokenMenos50;
              if (this.tokenMas!=''&& this.tokenMenos!='' || this.tokenMas!=''&& this.tokenMenos==''|| this.tokenMas==''&& this.tokenMenos!='') {
                this.token=true;
              }else{
                this.token=false;

              }
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      // this.programacionService.getStatusProgramacion(parseInt(localStorage.getItem('fechaProducto'))).subscribe( (data: backInter.getStatusIndiv) => {
      //   if(data.estatus === 3)
      //     this.pasoCompleto = true;
      // });
      // this.idiomasService.getNivelNotificacionCatServ(parseInt(localStorage.getItem('instituto_id'))).subscribe( (data: any) => {
      //   console.log('entro get catalogo niveles notificaciones',data);
      //   this.nivelNotificacion=data.catlNotificationBroker[0].secciones.encuesta.levelNotification;
      //   console.log('this.nivelNotificacion::',this.nivelNotificacion);
      // });
      // this.getStatusModal();
      this.getStatusEncuesta();
      // this.getAvance_Estatus();
      this.getHistorialActivarDesactivarSurveys();
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }



  getStatusModal(){
    let datos={
      productoId: this.productoCertificar.idNorma35,
      confirmacion: 1
    };
    console.log(datos);
    this.wizardService.getStatusModal(datos).subscribe( (data: backInter.getStatusModal) => {
      if(data.estatus==1){
            this.modalInformativo('CONFIRMACION');
      }
    });
  }
  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,

      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }

  updateStatusModal(){
    let datos={
      productoId: this.productoCertificar.idNorma35,
      confirmacion: 2
    };
    // console.log(datos);
    this.wizardService.updateStatusModal(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }

  calculoOffsetPipe(){
    this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == parseInt(localStorage.getItem('instituto_id')));
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    console.log("offsetPipe:",this.offsetPipe);
    console.log(localStorage.getItem('instituto_id'));
    // this.city_name='TOOLBAR.CITIES.'+localStorage.getItem('instituto_id');
  }
  traduceTextosTS(){
    this.idiomaUtc = this.translateSrv.currentLang;
    switch(this.translateSrv.currentLang){
      case 'es': this.idiomaActual = this.translateSrv.currentLang; break;
      case 'zh1': case 'zh2':
        if(this.instituto == 'HK'){
          this.idiomaActual = this.translateSrv.currentLang;
        }
        else{
          this.idiomaActual = 'en';
        }
      break;
      case 'tr':
        if(this.instituto == 'TK'){
          this.idiomaActual = this.translateSrv.currentLang;
        }
        else{
          this.idiomaActual = 'en';
        }
      break;
      default: this.idiomaActual = 'en';
    }
  }

  activarEncuesta(){
    let mensajeTexto1 = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.MESSAGE1';
    let mensajeTexto2 = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.MESSAGE2';
    let confirmarEmpresa = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.VALIDAR';
    this.translateSrv.get(mensajeTexto1).subscribe((res: string) => { mensajeTexto1 = res; });
    this.translateSrv.get(mensajeTexto2).subscribe((res: string) => { mensajeTexto2 = res; });
    this.translateSrv.get(confirmarEmpresa).subscribe((res: string) => { confirmarEmpresa = res; });

    let salir = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.SALIR';
    let errorNombreEmpresa = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.ERRORNOMBREEMPRESA';
    this.translateSrv.get(salir).subscribe((res: string) => { salir = res; });
    this.translateSrv.get(errorNombreEmpresa).subscribe((res: string) => { errorNombreEmpresa = res; });
    let cerrar = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.CERRAR';
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    let r = Math.random().toString(36).substring(7);
    console.log("cadena de datos aleatorios: ",r);
    let codigo=r;
    Swal.fire({
      title: mensajeTexto1+'<font color="red">'+codigo+'</font>'+mensajeTexto2,
      icon: 'info',
      input:'text',
      showCancelButton: true,
reverseButtons: true,


      cancelButtonText: salir,
      confirmButtonText: confirmarEmpresa
    })
    .then( (borrar) => {
      console.log(borrar);
      if (borrar.value==codigo) {

        this.actualizaEstatusEncuestaAbierta();
        // .then( (borrar) => {
        //   Swal.showLoading();
        //   console.log(borrar);
        //   if (borrar.value) {
        //     Swal.showLoading();
        //   }
        // });
      }
      else{
        if(!borrar.dismiss){
          Swal.fire({
          icon: 'error',
          title: errorNombreEmpresa,
          showConfirmButton: true,

          confirmButtonText: cerrar
          })
        }

      }
    });
  }


actualizaEstatusEncuestaAbierta(){
  let success = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.SUCCES';
  this.translateSrv.get(success).subscribe((res: string) => { success = res; });
  let estatus=3;
    let datos={
      status:1,
      accionText:'ActivaEstatEncu',
      userAdministrator:this.nameUserAdmin,
    }
    console.log("datos Open: ",datos);

    this.statusEncuestaNormaV3.updateSurveyStatus_vn35(this.productoCertificar.idNorma35,datos).subscribe((data:any) => {
      console.log(data);
      /*Swal.fire({
        title: success,
        icon: 'success',
        showCancelButton: false,

        confirmButtonText: 'Ok',
      })*/
      this.openSnackBar(success,"OK");
      // this.enviaOrdenWizardNotificiaciones();
      this.getStatusEncuesta();
      this.getHistorialActivarDesactivarSurveys();
      this.cambioEstatusConfirmacionCompleto(estatus);

    });
  }

  cambioEstatusConfirmacionCompleto(estatus){
    let datos:any;
     switch (estatus) {
       case 2:
       datos={
         accionText:'DescompletePasEstat',
         productoId:this.productoCertificar.idNorma35,
         confirmacion: 2,
         userAdministrator:this.nameUserAdmin,
         actualizar: 1,
       }

        break;
       case 3:
       datos={
         accionText:'completePasEstat',
         productoId:this.productoCertificar.idNorma35,
         confirmacion: 3,
         userAdministrator:this.nameUserAdmin,
         actualizar: 1,
       }

         break;
       default:
         break;
     }
console.log(datos);

    this.statusEncuestaNorma.guardaStatusConfirmacion(datos).subscribe( (data: backInter.RespuestaGen) => {
    console.log(data);
      if(data.message == '216' || data.message == '220'){
        this.enviaOrdenWizard();
      };
    });
  }

desactivarEncuesta(){
  let mensajeTexto1 = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.MESSAGE5';
  let mensajeTexto2 = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.MESSAGE6';
  let btnAceptar = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.BTN-ACEPTAR';
  let btnCancelar = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.BTN-CANCELAR';
  let btnOk = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.BTN-OK';
  this.translateSrv.get(mensajeTexto1).subscribe((res: string) => { mensajeTexto1 = res; });
  this.translateSrv.get(mensajeTexto2).subscribe((res: string) => { mensajeTexto2 = res; });
  this.translateSrv.get(btnAceptar).subscribe((res: string) => { btnAceptar = res; });
  this.translateSrv.get(btnCancelar).subscribe((res: string) => { btnCancelar = res; });
  this.translateSrv.get(btnOk).subscribe((res: string) => { btnOk = res; });

  if (this.token){
if(this.cerrarEncuestaResul>0){
Swal.fire({
  title: mensajeTexto1,
  icon: 'warning',
  showCancelButton: true,
reverseButtons: true,


  confirmButtonText: btnAceptar,
  cancelButtonText: btnCancelar
}).then((result) => {
  if (result.value) {
    this.codigoValidacionCerrarEncuesta();
  }
});
}else{
  this.codigoValidacionCerrarEncuesta();
}
}else{
  Swal.fire({
    title: mensajeTexto2,
    icon: 'warning',
    showCancelButton: false,

    confirmButtonText: btnOk,
  })
}

}


codigoValidacionCerrarEncuesta(){
    let mensajeTexto3 = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.MESSAGE3';
    let mensajeTexto4 = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.MESSAGE4';
    let confirmarEmpresa = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.VALIDAR';
    let salir = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.SALIR';
    let errorNombreEmpresa = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.ERRORNOMBREEMPRESA';
    let cerrar = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.CERRAR';

    this.translateSrv.get(mensajeTexto3).subscribe((res: string) => { mensajeTexto3 = res; });
    this.translateSrv.get(mensajeTexto4).subscribe((res: string) => { mensajeTexto4 = res; });
    this.translateSrv.get(confirmarEmpresa).subscribe((res: string) => { confirmarEmpresa = res; });
    this.translateSrv.get(salir).subscribe((res: string) => { salir = res; });
    this.translateSrv.get(errorNombreEmpresa).subscribe((res: string) => { errorNombreEmpresa = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    let r = Math.random().toString(36).substring(7);
    console.log("cadena de datos aleatorios: ",r);

    let codigo=r;
    Swal.fire({
      title: mensajeTexto3+'<font color="red">'+ codigo+'</font>'+mensajeTexto4,
      icon: 'info',
      input:'text',
      showCancelButton: true,
reverseButtons: true,


      cancelButtonText: salir,
      confirmButtonText: confirmarEmpresa
    })
    .then( (borrar) => {
      console.log(borrar);
      if (borrar.value==codigo) {

        this.actualizaEstatusEncuestaCerrado();


      }
      else{
        if(!borrar.dismiss){
          Swal.fire({
          icon: 'error',
          title: errorNombreEmpresa,
          showConfirmButton: true,

          confirmButtonText: cerrar
          })
        }

      }
    });
  }

  actualizaEstatusEncuestaCerrado(){
    let successdes = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.SUCCES-DES';
    this.translateSrv.get(successdes).subscribe((res: string) => { successdes = res; });
    let estatus=2;
    let datos={
      status:0,
      accionText:'DesacEstatEncu',
      userAdministrator:this.nameUserAdmin,
    }
    console.log("datos que cierran la encuesta: ",datos);

    this.statusEncuestaNormaV3.updateSurveyStatus_vn35(this.productoCertificar.idNorma35,datos).subscribe((data:any) => {
      console.log(data);
      this.openSnackBar(successdes,"OK");
      this.enviaOrdenWizardNotificiaciones();
      /*Swal.fire({
        title: successdes,
        icon: 'success',
        showCancelButton: false,

        confirmButtonText: 'Ok',
      })*/
      this.getStatusEncuesta();
      this.getHistorialActivarDesactivarSurveys();
      this.cambioEstatusConfirmacionCompleto(estatus);

    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  getStatusEncuesta(){

    this.statusEncuestaNormaV3.getStatusEncuestasNormaV3(this.tokenMas,this.tokenMenos).subscribe((resul: any)=>{
      console.log(resul);
      this.statusSurvey=resul.result.id_status
   });
  }

  getAvance_Estatus(){
    this.statusEncuesta.getResult_Encuesta(this.idSurvey,this.instituto,this.token).subscribe((resul: any)=>{
      console.log(resul);
      this.cerrarEncuestaResul=resul.result.endUsers;
      console.log("encuestas contestadas: ",this.cerrarEncuestaResul);

   });

  }

  enviaOrdenWizard(){
    this.wizardService35.puenteDatos("100"); //100 = actualiza los status de los steps
  }

  getHistorialActivarDesactivarSurveys(){
    this.statusEncuesta.getHistorialActivarDesactivarSurvey().subscribe((respuesta:any) => {
    console.log("Historial Acivacion y/o desactivacion de surveys : ", respuesta);
    this.historySurveyActiDesacti=respuesta.historial;
    this.fechaUltimaSurveyActiDesacti=respuesta.historial[respuesta.historial.length - 1];
    this.surveyActiDesacti=true;
    console.log(this.fechaUltimaSurveyActiDesacti);
    }, error => {
      console.log(error);
    });

  }

  enviaOrdenWizardNotificiaciones(){
    // this.wizardService.puenteDatosNotificaciones("100"); //100 = actualiza los status de los steps
    let datos:any={actua:"100",nivelNotif: this.nivelNotificacion}
    this.authService.puenteDatosQuick(datos);
  }
}
